var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: _vm._f("hashId")("mortgage-details[submission-details]") } },
    [
      _c(
        "div",
        {
          staticClass: "card pb-0 application-card",
          attrs: { id: "submission-details-" + _vm.currentMortgageIndex },
        },
        [
          _c("div", { staticClass: "card card-separator mb-1" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("div", { staticClass: "row align-items-end" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("div", [
                      _c("h2", { staticClass: "section-separator-title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "application-form.requested-mortgage-details"
                              )
                            ) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "h3",
                        { staticClass: "section-separator-title text-primary" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("application-form.type")) +
                              ": " +
                              _vm._s(_vm.mortgageIndexTitle) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.submissionDetailsLength > 1
                      ? _c(
                          "span",
                          [
                            _c("inline-prompt", {
                              staticClass: "d-inline-block bold text-gray ml-2",
                              attrs: {
                                "action-type": "delete",
                                "confirmation-text": _vm.$t(
                                  "application.messages.allDataWillBeLost"
                                ),
                              },
                              on: {
                                accept: function ($event) {
                                  return _vm.handleRemoveSubmission(
                                    _vm.mortgageIndexSelector,
                                    "['submission-details']"
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body px-5 pb-5" }, [
            _c(
              "div",
              { staticClass: "row align-items-end" },
              [
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "visibility-paths": [_vm.visibilityPaths.lender],
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      title: _vm.$t("application-form.lender"),
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group-material mb-2" },
                      [
                        _c("select2", {
                          ref: "select",
                          attrs: {
                            data: _vm.lenders,
                            name: "lenderName",
                            options: _vm.select2Options,
                            "format-data": _vm.formatData,
                            value: _vm.lender,
                            tabindex: "1100",
                          },
                          on: { change: _vm.changeLender },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "visibility-paths": [_vm.visibilityPaths.loanType],
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      title: _vm.$t("application-form.loan-type"),
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c("select-section", {
                      attrs: {
                        name: "loan-type",
                        "placeholder-option": !_vm.atLeastOneRequestedMortgage,
                        options: _vm.loanTypeOptions,
                        tabindex: "1100",
                      },
                      model: {
                        value: _vm.loanType,
                        callback: function ($$v) {
                          _vm.loanType = $$v
                        },
                        expression: "loanType",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "visibility-paths": [_vm.visibilityPaths.maturityDate],
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      title: _vm.$t("application-form.maturity-date"),
                      disabled: "",
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c("date-section", {
                      attrs: {
                        value: _vm.calculatedValues.maturityDate,
                        name: "maturity-date",
                        placeholder: "YYYY-MM-DD",
                        "class-name": "date-format",
                        tabindex: "1100",
                        "maturity-date": true,
                        disabled: true,
                        label: _vm.$t("application-form.maturity-date"),
                      },
                      on: { change: _vm.handleSave },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row align-items-end" },
              [
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      "visibility-paths": [_vm.visibilityPaths.mortgageType],
                      title: _vm.$t("application-form.mortgage-type"),
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c("select-section", {
                      attrs: {
                        value: _vm.mortgageType,
                        name: "mortgage-type",
                        placeholder: _vm.mortgageTypePlaceholder,
                        options: _vm.filteredMortgageTypeOptions,
                        disabled: !_vm.atLeastOneRequestedMortgage,
                        tabindex: "1100",
                      },
                      on: { change: _vm.changeMortgageIndex },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "visibility-paths": [
                        _vm.visibilityPaths.firstPaymentDate,
                      ],
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      title: _vm.$t("application-form.first-payment-date"),
                      disabled: "",
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c("date-section", {
                      attrs: {
                        value: _vm.calculatedValues.firstPaymentDate,
                        name: "first-payment-date",
                        placeholder: "YYYY-MM-DD",
                        "class-name": "date-format",
                        tabindex: "1100",
                        disabled: true,
                        label: _vm.$t("application-form.first-payment-date"),
                      },
                      on: { change: _vm.handleSave },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "visibility-paths": [_vm.visibilityPaths.progressAdvance],
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      title: _vm.$t("application-form.progress-advance"),
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c("select-section", {
                      attrs: {
                        name: "progress-advance",
                        options: _vm.basicBinaryOptions,
                        tabindex: "1100",
                      },
                      model: {
                        value: _vm.progressAdvance,
                        callback: function ($$v) {
                          _vm.progressAdvance = $$v
                        },
                        expression: "progressAdvance",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row align-items-end" },
              [
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "visibility-paths": [
                        _vm.visibilityPaths.interestAdjustmentDate,
                      ],
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      title: _vm.$t(
                        "application-form.interest-adjustment-date"
                      ),
                      icon:
                        _vm.disabledByAcceptedSubmissionIconByMortgage[
                          _vm.currentMortgageType
                        ] || "",
                      "icon-tooltip":
                        _vm.disabledByAcceptedSubmissionTooltipTextByMortgage[
                          _vm.currentMortgageType
                        ] || "",
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c("date-section", {
                      attrs: {
                        name: "interest-adjustment-date",
                        placeholder: "YYYY-MM-DD",
                        "class-name": "date-format",
                        disabled:
                          _vm.disabledByAcceptedSubmissionInputByMortgage[
                            _vm.currentMortgageType
                          ],
                        tabindex: "1100",
                        label: _vm.$t(
                          "application-form.interest-adjustment-date"
                        ),
                      },
                      on: { change: _vm.handleSave },
                      model: {
                        value: _vm.interestAdjustmentDate,
                        callback: function ($$v) {
                          _vm.interestAdjustmentDate = $$v
                        },
                        expression: "interestAdjustmentDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "field",
                  {
                    attrs: {
                      "edit-visibility": _vm.editVisibility,
                      "visibility-paths": [_vm.visibilityPaths.lineOfBusiness],
                      "size-class": "col-lg-4 col-sm-6 col-12",
                      title: _vm.$t("application-form.line-of-business"),
                    },
                    on: { "toggle-visibility": _vm.handleVisibility },
                  },
                  [
                    _c("select-section", {
                      attrs: {
                        name: "line-of-business",
                        options: _vm.lineOfBusinessOptions,
                        tabindex: "1100",
                      },
                      model: {
                        value: _vm.lineOfBusiness,
                        callback: function ($$v) {
                          _vm.lineOfBusiness = $$v
                        },
                        expression: "lineOfBusiness",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "card-footer py-1 px-5 bg-light d-flex justify-content-end",
            },
            [
              _c(
                "field",
                {
                  attrs: {
                    "edit-visibility": _vm.editVisibility,
                    "hide-eye": true,
                    "size-class": "col-auto pr-3",
                    title: _vm.$t(
                      "application-form.interest-adjustment-amount"
                    ),
                    "container-class": "dollar-prepend calculated",
                    calculated: true,
                    "side-label": true,
                    "side-label-size": "col-auto",
                  },
                  on: { "toggle-visibility": _vm.handleVisibility },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "interest-adjustment-amount calculated",
                      value: _vm.calculatedValues.interestAdjustmentAmount,
                      placeholder: "0",
                      "class-name": "fe-num-field calculated dollar",
                      calculated: true,
                      loading: _vm.calculatedValues.loading,
                      label: _vm.$t(
                        "application-form.interest-adjustment-amount"
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "card application-card",
                attrs: { id: "mortgage-classification" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header border-top",
                    attrs: {
                      id: _vm._f("hashId")(
                        "submission-details[" +
                          _vm.mortgageIndexSelector +
                          "][mortgage-classifications]"
                      ),
                    },
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c("div", { staticClass: "col-11" }, [
                        _c("h2", { staticClass: "section-separator-title" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$t(
                                  "application-form.mortgage-classification"
                                )
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "h3",
                          {
                            staticClass: "section-separator-title text-primary",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.mortgageIndexTitle) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.editVisibility
                        ? _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("multiple-visibility-button", {
                                attrs: {
                                  "visibility-paths":
                                    _vm.PagesVisibilityMap[
                                      "mortgage-classification"
                                    ],
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body pb-5" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    _vm._l(
                      _vm.classificationsData,
                      function (classification, classIndex) {
                        return _c(
                          "field",
                          {
                            key: classIndex,
                            attrs: {
                              "edit-visibility": _vm.editVisibility,
                              "visibility-paths": [
                                _vm.visibilityPaths[
                                  classification.path || classification.name
                                ],
                              ],
                              title: _vm.editVisibility
                                ? classification.title
                                : "",
                              "size-class": "col-lg-2 col-sm-4 col-6",
                            },
                            on: { "toggle-visibility": _vm.handleVisibility },
                          },
                          [
                            _c("checkbox-section", {
                              attrs: {
                                checked: _vm.getClassification(
                                  classification,
                                  _vm.mortgageIndexSelector
                                ),
                                name:
                                  (classification.path || classification.name) +
                                  "-" +
                                  _vm.mortgageIndexSelector,
                                label: _vm.editVisibility
                                  ? ""
                                  : classification.title,
                                tabindex: "1200",
                              },
                              on: {
                                change: function (val) {
                                  return _vm.setClassification(
                                    val,
                                    classification,
                                    _vm.mortgageIndexSelector
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("generic-modal", {
                  ref: "suspiciousTransactionModal",
                  attrs: { id: "suspiciousTransaction" },
                  scopedSlots: _vm._u([
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "application-form.suspicious-transactionmodalbody"
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "card pb-0 application-card",
                attrs: { id: "additional-details" },
              },
              [
                _c("div", { staticClass: "card-header border-top" }, [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _c("div", { staticClass: "col-11" }, [
                      _c("h2", { staticClass: "section-separator-title" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("application-form.additional-details")
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "h3",
                        { staticClass: "section-separator-title text-primary" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.mortgageIndexTitle) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.editVisibility
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("multiple-visibility-button", {
                              attrs: {
                                "visibility-paths":
                                  _vm.PagesVisibilityMap["additional-details"],
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5 pb-5" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-start" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.includeInMortgage,
                            ],
                            "size-class":
                              "col-lg-4 col-md-6 col-12 radio-field",
                            title: _vm.$t(
                              "application-form.include-insurance-in-mortgage"
                            ),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("radio-section", {
                            attrs: {
                              name:
                                "include-in-mortgage-" +
                                _vm.mortgageIndexSelector,
                              options: _vm.basicBinaryOptions,
                              tabindex: "1200",
                            },
                            model: {
                              value: _vm.includeInMortgage,
                              callback: function ($$v) {
                                _vm.includeInMortgage = $$v
                              },
                              expression: "includeInMortgage",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.locRepaymentType,
                            ],
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t(
                              "application-form.loc-repayment-type"
                            ),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("select-section", {
                            attrs: {
                              name:
                                "loc-repayment-type-" +
                                _vm.mortgageIndexSelector,
                              options: _vm.locRepaymentOptions,
                              tabindex: "1200",
                            },
                            model: {
                              value: _vm.locRepaymentType,
                              callback: function ($$v) {
                                _vm.locRepaymentType = $$v
                              },
                              expression: "locRepaymentType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-footer py-1 px-5 bg-light d-flex justify-content-end flex-row align-items-center flex-wrap",
                  },
                  [
                    !_vm.editVisibility &&
                    !_vm.disabledByAcceptedSubmissionInputByMortgage[
                      _vm.currentMortgageType
                    ]
                      ? _c(
                          "field",
                          {
                            attrs: {
                              "size-class": "col-auto",
                              "container-class":
                                "d-flex flex-column align-items-center",
                            },
                          },
                          [
                            _c("checkbox-section", {
                              attrs: {
                                name:
                                  "override-premium-rate-" +
                                  _vm.mortgageIndexSelector,
                                "container-class": "mb-0 font-sm text-success",
                                label: _vm.$t(
                                  "application-form.override-premium-rate"
                                ),
                                tabindex: "1200",
                              },
                              model: {
                                value: _vm.miPremiumOverride,
                                callback: function ($$v) {
                                  _vm.miPremiumOverride = $$v
                                },
                                expression: "miPremiumOverride",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: {
                            title: _vm.$t("application-form.premiumTooltip"),
                          },
                          expression:
                            "{\n                title: $t('application-form.premiumTooltip')\n              }",
                        },
                      ],
                      staticClass: "fa fa-info-circle",
                    }),
                    _vm._v(" "),
                    _c(
                      "field",
                      {
                        attrs: {
                          "edit-visibility": _vm.editVisibility,
                          "hide-eye": true,
                          "size-class": "col-auto",
                          title: _vm.$t("application-form.premium-rate"),
                          "side-label": true,
                          "side-label-size": "col-auto",
                          "container-class": "perc-append",
                          calculated: !_vm.miPremiumOverride,
                          icon:
                            _vm.disabledByAcceptedSubmissionIconByMortgage[
                              _vm.currentMortgageType
                            ] || "",
                          "icon-tooltip":
                            _vm
                              .disabledByAcceptedSubmissionTooltipTextByMortgage[
                              _vm.currentMortgageType
                            ] || "",
                        },
                        on: { "toggle-visibility": _vm.handleVisibility },
                      },
                      [
                        _c("text-section", {
                          attrs: {
                            name: "premium-rate",
                            placeholder: "0.00",
                            "class-name": "rate calculated",
                            calculated: !_vm.miPremiumOverride,
                            loading: _vm.calculatedValues.loading,
                            disabled:
                              _vm.disabledByAcceptedSubmissionInputByMortgage[
                                _vm.currentMortgageType
                              ],
                            label: _vm.$t("application-form.premium-rate"),
                            tabindex: "1200",
                          },
                          model: {
                            value: _vm.computedMiPremiumRate,
                            callback: function ($$v) {
                              _vm.computedMiPremiumRate = $$v
                            },
                            expression: "computedMiPremiumRate",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "field",
                      {
                        attrs: {
                          "edit-visibility": _vm.editVisibility,
                          "hide-eye": true,
                          "size-class": "col-auto",
                          title: _vm.$t(
                            "application-form.mortgage-insurance-premium"
                          ),
                          "side-label": true,
                          "side-label-size": "col-auto",
                          "container-class": "dollar-prepend",
                          calculated: !_vm.miPremiumOverride,
                          icon:
                            _vm.disabledByAcceptedSubmissionIconByMortgage[
                              _vm.currentMortgageType
                            ] || "",
                          "icon-tooltip":
                            _vm
                              .disabledByAcceptedSubmissionTooltipTextByMortgage[
                              _vm.currentMortgageType
                            ] || "",
                        },
                        on: { "toggle-visibility": _vm.handleVisibility },
                      },
                      [
                        _c("text-section", {
                          attrs: {
                            name: "mortgage-insurance-premium",
                            placeholder: "0",
                            "class-name": "fe-num-field dollar calculated",
                            calculated: !_vm.miPremiumOverride,
                            loading: _vm.calculatedValues.loading,
                            disabled:
                              _vm.disabledByAcceptedSubmissionInputByMortgage[
                                _vm.currentMortgageType
                              ],
                            label: _vm.$t(
                              "application-form.mortgage-insurance-premium"
                            ),
                            tabindex: "1200",
                          },
                          model: {
                            value: _vm.computedMiPremiumAmount,
                            callback: function ($$v) {
                              _vm.computedMiPremiumAmount = $$v
                            },
                            expression: "computedMiPremiumAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "card pb-0 application-card",
                attrs: { id: "rate-details" },
              },
              [
                _c("div", { staticClass: "card-header border-top" }, [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _c("div", { staticClass: "col-11" }, [
                      _c("h2", { staticClass: "section-separator-title" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("application-form.rate-details")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "h3",
                        { staticClass: "section-separator-title text-primary" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.mortgageIndexTitle) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.editVisibility
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("multiple-visibility-button", {
                              attrs: {
                                "visibility-paths":
                                  _vm.PagesVisibilityMap["rate-details"],
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5 pb-5" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-4 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "row align-items-end" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.interestRate,
                                ],
                                "size-class": "col-lg-8 col-md-6 col-12",
                                title: _vm.$t("application-form.interest-rate"),
                                "side-label": true,
                                "side-label-size": "col-6",
                                "container-class": "perc-append",
                                icon:
                                  _vm
                                    .disabledByAcceptedSubmissionIconByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                                "icon-tooltip":
                                  _vm
                                    .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "interest-rate",
                                  placeholder: "0.00",
                                  "class-name": "rate",
                                  "allow-minus":
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ],
                                  disabled:
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ],
                                  tabindex: "1300",
                                  label: _vm.$t(
                                    "application-form.interest-rate"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleChangeRates("interestRate")
                                  },
                                },
                                model: {
                                  value: _vm.interestRate,
                                  callback: function ($$v) {
                                    _vm.interestRate = $$v
                                  },
                                  expression: "interestRate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.discountRate,
                                ],
                                "size-class": "col-lg-8 col-md-6 col-12",
                                title: _vm.$t("application-form.discount-rate"),
                                "side-label": true,
                                "side-label-size": "col-6",
                                "container-class": "perc-append",
                                "validator-context": _vm.$v,
                                "custom-expression": "discountRate",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "discount-rate",
                                  placeholder: "0.00",
                                  "class-name": "rate",
                                  tabindex: "1300",
                                  "show-tooltip-message": "",
                                  label: _vm.$t(
                                    "application-form.discount-rate"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleChangeRates("discountRate")
                                  },
                                },
                                model: {
                                  value: _vm.discountRate,
                                  callback: function ($$v) {
                                    _vm.discountRate = $$v
                                  },
                                  expression: "discountRate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.premiumRate,
                                ],
                                "size-class": "col-lg-8 col-md-6 col-12",
                                title: _vm.$t("application-form.premium-rate"),
                                "side-label": true,
                                "side-label-size": "col-6",
                                "container-class": "perc-append",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "premium-rate",
                                  placeholder: "0.00",
                                  "class-name": "rate",
                                  tabindex: "1300",
                                  label: _vm.$t(
                                    "application-form.premium-rate"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleChangeRates("premiumRate")
                                  },
                                },
                                model: {
                                  value: _vm.premiumRate,
                                  callback: function ($$v) {
                                    _vm.premiumRate = $$v
                                  },
                                  expression: "premiumRate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.buyDownRate,
                                ],
                                "size-class": "col-lg-8 col-md-6 col-12",
                                title: _vm.$t("application-form.buy-down-rate"),
                                "side-label": true,
                                "side-label-size": "col-6",
                                "container-class": "perc-append",
                                "validator-context": _vm.$v,
                                "custom-expression": "buyDownRate",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "buy-down-rate",
                                  placeholder: "0.00",
                                  "class-name": "rate",
                                  tabindex: "1300",
                                  "show-tooltip-message": "",
                                  label: _vm.$t(
                                    "application-form.buy-down-rate"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleChangeRates("buyDownRate")
                                  },
                                },
                                model: {
                                  value: _vm.buyDownRate,
                                  callback: function ($$v) {
                                    _vm.buyDownRate = $$v
                                  },
                                  expression: "buyDownRate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.variableToPrime,
                                ],
                                "size-class": "col-lg-8 col-md-6 col-12",
                                title: _vm.$t(
                                  "application-form.variable-to-prime"
                                ),
                                "side-label": true,
                                "side-label-size": "col-6",
                                "container-class": "perc-append",
                                "validator-context": _vm.$v,
                                "custom-expression": "variableToPrime",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "variable-to-prime",
                                  placeholder: "0.00",
                                  disabled: _vm.rateType == "fixed",
                                  "allow-minus": "",
                                  "allow-plus": "",
                                  "class-name": "rate",
                                  tabindex: "1300",
                                  label: _vm.$t(
                                    "application-form.variable-to-prime"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleChangeRates(
                                      "variableToPrime"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.variableToPrime,
                                  callback: function ($$v) {
                                    _vm.variableToPrime = $$v
                                  },
                                  expression: "variableToPrime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-8 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "row align-items-end" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.rateType,
                                ],
                                "size-class": "col-lg-4 col-md-6 col-12",
                                title: _vm.$t("application-form.rate-type"),
                                icon:
                                  _vm
                                    .disabledByAcceptedSubmissionIconByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                                "icon-tooltip":
                                  _vm
                                    .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  name: "rate-type",
                                  options: _vm.rateTypeOptions,
                                  disabled:
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ],
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.rateType,
                                  callback: function ($$v) {
                                    _vm.rateType = $$v
                                  },
                                  expression: "rateType",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.termYears,
                                  _vm.visibilityPaths.termMonths,
                                ],
                                "size-class": "col-lg-8 col-md-6 col-12",
                                title: _vm.$t("application-form.term"),
                                icon:
                                  _vm
                                    .disabledByAcceptedSubmissionIconByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                                "icon-tooltip":
                                  _vm
                                    .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("years-months-section", {
                                attrs: {
                                  name: "term",
                                  "class-name": "fe-num-field",
                                  disabled:
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ],
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.termYearsAndMonths,
                                  callback: function ($$v) {
                                    _vm.termYearsAndMonths = $$v
                                  },
                                  expression: "termYearsAndMonths",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row align-items-center" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.termType,
                                ],
                                "size-class": "col-lg-4 col-md-6 col-12",
                                title: _vm.$t("application-form.term-type"),
                                icon:
                                  _vm
                                    .disabledByAcceptedSubmissionIconByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                                "icon-tooltip":
                                  _vm
                                    .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  name: "term-type",
                                  options: _vm.termTypeOptions,
                                  disabled:
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ],
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.termType,
                                  callback: function ($$v) {
                                    _vm.termType = $$v
                                  },
                                  expression: "termType",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "visibility-paths": [
                                  _vm.visibilityPaths.amortizationYears,
                                  _vm.visibilityPaths.amortizationMonths,
                                ],
                                "edit-visibility": _vm.editVisibility,
                                "size-class": "col-lg-8 col-md-6 col-12",
                                title: _vm.$t("application-form.amortization"),
                                icon:
                                  _vm
                                    .disabledByAcceptedSubmissionIconByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                                "icon-tooltip":
                                  _vm
                                    .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("years-months-section", {
                                attrs: {
                                  name: "amortization",
                                  "class-name": "fe-num-field",
                                  disabled:
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ] || !!_vm.interestOnly,
                                  "force-zero-placeholder": "",
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.amortizationYearsAndMonths,
                                  callback: function ($$v) {
                                    _vm.amortizationYearsAndMonths = $$v
                                  },
                                  expression: "amortizationYearsAndMonths",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.frequency,
                                ],
                                "size-class": "col-lg-4 col-md-6 col-12",
                                title: _vm.$t("application-form.frequency"),
                                icon:
                                  _vm
                                    .disabledByAcceptedSubmissionIconByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                                "icon-tooltip":
                                  _vm
                                    .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  name: "frequency",
                                  options: _vm.frequencyOptions,
                                  disabled:
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ],
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.frequency,
                                  callback: function ($$v) {
                                    _vm.frequency = $$v
                                  },
                                  expression: "frequency",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.blendedAmortization,
                                ],
                                "size-class": "col-lg-4 col-md-6 col-12",
                                title: _vm.editVisibility
                                  ? _vm.$t(
                                      "application-form.blended-amortization"
                                    )
                                  : "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("checkbox-section", {
                                attrs: {
                                  name:
                                    "blended-amortization-" +
                                    _vm.mortgageIndexSelector,
                                  label: _vm.editVisibility
                                    ? ""
                                    : _vm.$t(
                                        "application-form.blended-amortization"
                                      ),
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.blendedAmortization,
                                  callback: function ($$v) {
                                    _vm.blendedAmortization = $$v
                                  },
                                  expression: "blendedAmortization",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.interestOnly,
                                ],
                                "size-class": "ml-3",
                                title: _vm.editVisibility
                                  ? _vm.$t("application-form.interest-only")
                                  : "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("checkbox-section", {
                                attrs: {
                                  name:
                                    "interest-only-submission-details-" +
                                    _vm.mortgageIndexSelector,
                                  label: _vm.editVisibility
                                    ? ""
                                    : _vm.$t("application-form.interest-only"),
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.interestOnly,
                                  callback: function ($$v) {
                                    _vm.interestOnly = $$v
                                  },
                                  expression: "interestOnly",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.compoundedPeriod,
                                ],
                                "size-class": "col-12 radio-field",
                                title: _vm.$t(
                                  "application-form.compounding-period"
                                ),
                                icon:
                                  _vm
                                    .disabledByAcceptedSubmissionIconByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                                "icon-tooltip":
                                  _vm
                                    .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                    _vm.currentMortgageType
                                  ] || "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("radio-section", {
                                attrs: {
                                  name:
                                    "compounding-period-submission-details-" +
                                    _vm.mortgageIndexSelector,
                                  options: _vm.compoundingPeriodOptions,
                                  disabled:
                                    _vm
                                      .disabledByAcceptedSubmissionInputByMortgage[
                                      _vm.currentMortgageType
                                    ],
                                  tabindex: "1300",
                                },
                                model: {
                                  value: _vm.compoundedPeriod,
                                  callback: function ($$v) {
                                    _vm.compoundedPeriod = $$v
                                  },
                                  expression: "compoundedPeriod",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-footer py-1 px-5 bg-light d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "field",
                      {
                        attrs: {
                          "edit-visibility": _vm.editVisibility,
                          "size-class": "col-auto",
                          "hide-eye": true,
                          title: _vm.$t("application-form.net-rate"),
                          "side-label": true,
                          "side-label-size": "col-auto",
                          "container-class": "perc-append",
                          calculated: true,
                        },
                        on: { "toggle-visibility": _vm.handleVisibility },
                      },
                      [
                        _c("text-section", {
                          attrs: {
                            value: _vm.calculatedValues.netRate,
                            name: "buy-down-rate",
                            placeholder: "0.00",
                            "class-name": "rate calculated",
                            calculated: true,
                            loading: _vm.calculatedValues.loading,
                            "formatted-decimals": 3,
                            tabindex: "1300",
                            label: _vm.$t("application-form.net-rate"),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(
                          "field",
                          {
                            attrs: {
                              "size-class": "col-auto ml-3",
                              "hide-eye": true,
                              title: _vm.$t("application.calculations.gds"),
                              "side-label": true,
                              "side-label-size": "col-auto",
                              "container-class": "perc-append",
                              calculated: true,
                            },
                          },
                          [
                            _c("text-section", {
                              attrs: {
                                value: _vm.calculatedValues.gds || 0,
                                name: "gds-total",
                                placeholder: "0.00",
                                "class-name": "rate calculated",
                                calculated: true,
                                "formatted-decimals": 3,
                                loading: _vm.calculatedValues.loading,
                                label: _vm.$t("application.calculations.gds"),
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "field",
                          {
                            attrs: {
                              "size-class": "col-auto ml-3",
                              "hide-eye": true,
                              title: _vm.$t("application.calculations.tds"),
                              "side-label": true,
                              "side-label-size": "col-auto",
                              "container-class": "perc-append",
                              calculated: true,
                            },
                          },
                          [
                            _c("text-section", {
                              attrs: {
                                value: _vm.calculatedValues.tds || 0,
                                name: "tds-total",
                                placeholder: "0.00",
                                "class-name": "rate calculated",
                                calculated: true,
                                "formatted-decimals": 3,
                                loading: _vm.calculatedValues.loading,
                                label: _vm.$t("application.calculations.tds"),
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.calculatedValues.pAndIPaymentAmount !== undefined
                          ? _c(
                              "field",
                              {
                                attrs: {
                                  "size-class": "col-auto ml-3",
                                  "hide-eye": true,
                                  title: _vm.$t(
                                    "application-form.frequency-payment"
                                  ),
                                  "side-label": true,
                                  "side-label-size": "col-auto",
                                  "container-class": "dollar-prepend",
                                  calculated: true,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    value:
                                      _vm.calculatedValues.pAndIPaymentAmount,
                                    name: "pandi-payment",
                                    placeholder: "0",
                                    "class-name":
                                      "fe-num-field dollar calculated",
                                    calculated: true,
                                    "formatted-decimals": 3,
                                    loading: _vm.calculatedValues.loading,
                                    label: _vm.$t(
                                      "application-form.frequency-payment"
                                    ),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.calculatedValues.pAndIPaymentAmountMonthly !==
                        undefined
                          ? _c(
                              "field",
                              {
                                attrs: {
                                  "size-class": "col-auto ml-3",
                                  "hide-eye": true,
                                  title: _vm.$t(
                                    "application-form.monthly-payment"
                                  ),
                                  "side-label": true,
                                  "side-label-size": "col-auto",
                                  "container-class": "dollar-prepend",
                                  calculated: true,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    value:
                                      _vm.calculatedValues
                                        .pAndIPaymentAmountMonthly,
                                    name: "monthly-payment",
                                    placeholder: "0",
                                    "class-name":
                                      "fe-num-field dollar calculated",
                                    calculated: true,
                                    "formatted-decimals": 3,
                                    loading: _vm.calculatedValues.loading,
                                    label: _vm.$t(
                                      "application-form.monthly-payment"
                                    ),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "card application-card",
                attrs: { id: "qualifying-details" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header border-top",
                    attrs: {
                      id: _vm._f("hashId")(
                        "submission-details[" +
                          _vm.mortgageIndexSelector +
                          "][qualifying-details]"
                      ),
                    },
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c("div", { staticClass: "col-11" }, [
                        _c("h2", { staticClass: "section-separator-title" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$t("application-form.qualifying-details")
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "h3",
                          {
                            staticClass: "section-separator-title text-primary",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.mortgageIndexTitle) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.editVisibility
                        ? _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("multiple-visibility-button", {
                                attrs: {
                                  "visibility-paths":
                                    _vm.PagesVisibilityMap[
                                      "qualifying-details"
                                    ],
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body pb-5" },
                  [
                    _c("qualifying-details", {
                      attrs: {
                        "calculated-values": _vm.calculatedValues,
                        "edit-visibility": _vm.editVisibility,
                        "path-name": _vm.pathName,
                        "mortgage-index": _vm.mortgageIndexSelector,
                      },
                      on: { "toggle-visibility": _vm.handleVisibility },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-footer py-1 bg-light d-flex justify-content-end",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(
                          "field",
                          {
                            attrs: {
                              "size-class": "col-auto ml-3",
                              "hide-eye": true,
                              title:
                                _vm.$t("global.words.qualifying") +
                                " " +
                                _vm.$t("application.calculations.gds"),
                              "side-label": true,
                              "side-label-size": "col-auto",
                              "container-class": "perc-append",
                              calculated: true,
                            },
                          },
                          [
                            _c("text-section", {
                              attrs: {
                                value: _vm.calculatedValues.qualifyingGds || 0,
                                name: "gds-qualify",
                                placeholder: "0.00",
                                "class-name": "rate calculated",
                                calculated: true,
                                "formatted-decimals": 3,
                                loading: _vm.calculatedValues.loading,
                                label:
                                  _vm.$t("global.words.qualifying") +
                                  " " +
                                  _vm.$t("application.calculations.gds"),
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "field",
                          {
                            attrs: {
                              "size-class": "col-auto ml-3",
                              "hide-eye": true,
                              title:
                                _vm.$t("global.words.qualifying") +
                                " " +
                                _vm.$t("application.calculations.tds"),
                              "side-label": true,
                              "side-label-size": "col-auto",
                              "container-class": "perc-append",
                              calculated: true,
                            },
                          },
                          [
                            _c("text-section", {
                              attrs: {
                                value: _vm.calculatedValues.qualifyingTds || 0,
                                name: "tds-qualify",
                                placeholder: "0.00",
                                "class-name": "rate calculated",
                                calculated: true,
                                "formatted-decimals": 3,
                                loading: _vm.calculatedValues.loading,
                                label:
                                  _vm.$t("global.words.qualifying") +
                                  " " +
                                  _vm.$t("application.calculations.tds"),
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "field",
                          {
                            attrs: {
                              "size-class": "col-auto ml-3",
                              "hide-eye": true,
                              title:
                                _vm.$t("global.words.qualifying") +
                                " " +
                                _vm.$t("application-form.frequency-payment"),
                              "side-label": true,
                              "side-label-size": "col-auto",
                              "container-class": "dollar-prepend",
                              calculated: true,
                            },
                          },
                          [
                            _c("text-section", {
                              attrs: {
                                value:
                                  _vm.calculatedValues
                                    .pAndIPaymentFrequencyQualify || 0,
                                name: "qualifying-frequency-payment",
                                placeholder: "0",
                                "class-name": "fe-num-field dollar calculated",
                                calculated: true,
                                "formatted-decimals": 3,
                                loading: _vm.calculatedValues.loading,
                                label:
                                  _vm.$t("global.words.qualifying") +
                                  " " +
                                  _vm.$t("application-form.frequency-payment"),
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "field",
                          {
                            attrs: {
                              "size-class": "col-auto ml-3",
                              "hide-eye": true,
                              title:
                                _vm.$t("global.words.qualifying") +
                                " " +
                                _vm.$t("application-form.monthly-payment"),
                              "side-label": true,
                              "side-label-size": "col-auto",
                              "container-class": "dollar-prepend",
                              calculated: true,
                            },
                          },
                          [
                            _c("text-section", {
                              attrs: {
                                value:
                                  _vm.calculatedValues
                                    .pAndIPaymentAmountQualify || 0,
                                name: "qualifying-monthly-payment",
                                placeholder: "0",
                                "class-name": "fe-num-field dollar calculated",
                                calculated: true,
                                "formatted-decimals": 3,
                                loading: _vm.calculatedValues.loading,
                                label:
                                  _vm.$t("global.words.qualifying") +
                                  " " +
                                  _vm.$t("application-form.monthly-payment"),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "card pb-0 application-card" }, [
              _c("div", { staticClass: "card-header border-top" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col-11" }, [
                    _c("h2", { staticClass: "section-separator-title" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$t(
                              "application-form.applicantsAssignedToMortgage"
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body px-5 pb-5" },
                [
                  _vm._l(
                    _vm.applicantsForMortgageSelection,
                    function (applicant, index) {
                      return [
                        _c(
                          "div",
                          { key: index, staticClass: "row pl-3 mb-3" },
                          [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "div",
                                { staticClass: "row align-items-end" },
                                [
                                  _c("b", { staticClass: "mr-1" }, [
                                    _vm._v(
                                      _vm._s(applicant.applicantType) + ": "
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(applicant.fullName) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-form.assignedToMortgage"
                                    )
                                  ) +
                                  "\n                  "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-jelly p-smooth p-curve ml-1",
                                },
                                [
                                  index == 0
                                    ? _c("input", {
                                        staticClass: "checkbox",
                                        attrs: {
                                          type: "checkbox",
                                          checked: "true",
                                          disabled: "",
                                        },
                                      })
                                    : _c("input", {
                                        staticClass: "checkbox",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked:
                                            _vm.isApplicantAssociatedToMortgage(
                                              applicant.id
                                            ),
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.toggleApplicantSubmissionExclusion(
                                              applicant.id
                                            )
                                          },
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "state p-success" },
                                    [
                                      _c("i", {
                                        staticClass: "icon fa fa-check",
                                      }),
                                      _vm._v(" "),
                                      _c("label", [
                                        _c(
                                          "span",
                                          { staticStyle: { display: "none" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "application-form.assignedToMortgage"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    }
                  ),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }